import { LocalizationProvider as LocalizationProviderBase } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import type { FC, PropsWithChildren } from 'react';
import { useLocale } from '@pflegenavi/frontend/localization';
import { deAT, enGB } from 'date-fns/locale';

const LOCALE_MAP = {
  'en-GB': enGB,
  'de-AT': deAT,
  cimode: deAT,
};

export const LocalizationProvider: FC<PropsWithChildren> = ({ children }) => {
  const locale = useLocale();

  const getLocale = () => {
    return LOCALE_MAP[locale] ?? deAT;
  };

  return (
    <LocalizationProviderBase
      dateAdapter={AdapterDateFns}
      adapterLocale={getLocale()}
    >
      {children}
    </LocalizationProviderBase>
  );
};
